import { SelectOption } from '@navstation-portal/shared/data-model/common';

/**
 * Gives the option of the list whose code TVA stores for a select field, or
 * undefined when the field holds no code.
 */
export const convertCodeToOption = (code: string | undefined, options: SelectOption[]): SelectOption | undefined => {
  if (code == null || code === '') return undefined;
  return options.find((option) => option.code === code);
};
